import type { ShippingMethods } from "@store/types";

import type { MagentoApiSetShippingAddressesOnCartWithMethodsMutationResponse } from "@jti/magento-api-v2";
import type { ApiMagentoAddress } from "@jti/magento-types";

import { TAGS } from "../common/tags";
import type { MagentoApiBuilder } from "../magentoApiSlice";
import { normalizeShippingMethods } from "../utils";

type SetShippingAddressOnCartWithMethodsPayload = {
  cartId: string;
  address: ApiMagentoAddress;
};

export type SetShippingAddressOnCartWithMethodsResult = ShippingMethods;

export const setShippingAddressOnCartWithMethodsEndpoint = (builder: MagentoApiBuilder) => ({
  /**
   * Sets the shipping address and returns the available shipping methods in a single round trip.
   * The getShippingMethods cache is updated via a listener in magento.listeners.ts.
   */
  setShippingAddressOnCartWithMethods: builder.mutation<
    SetShippingAddressOnCartWithMethodsResult,
    SetShippingAddressOnCartWithMethodsPayload
  >({
    query: ({ cartId, address }) => ({
      method: "setShippingAddressesOnCartWithMethods",
      params: [{ cartId, address }],
    }),
    transformResponse: (response: MagentoApiSetShippingAddressesOnCartWithMethodsMutationResponse) =>
      normalizeShippingMethods(response.setShippingAddressesOnCart?.cart.shipping_addresses?.[0]),
    invalidatesTags: [TAGS.ORDER_DELIVERY_LIMITS, TAGS.CART_ITEMS, TAGS.CART_ORDER_PRICES],
  }),
});
